import React, { useState } from 'react';
import { mockData } from '../mock';

// Clean Hero Section - Left text, Right photo, Background conference image
export const CleanHeroSection = () => (
  <section 
    className="relative min-h-screen flex items-center"
    style={{
      backgroundImage: `url('${mockData.hero.backgroundImage}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }}
  >
    {/* Strong overlay for readability */}
    <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 via-gray-800/75 to-gray-900/60"></div>
    
    <div className="relative z-10 container mx-auto px-8 py-20">
      <div className="grid lg:grid-cols-2 gap-20 items-center max-w-7xl mx-auto">
        
        {/* Left - Content */}
        <div className="space-y-10">
          
          {/* Trust Badges */}
          <div className="flex flex-wrap gap-3 mb-6">
            {mockData.hero.trustBadges.map((badge, index) => (
              <div key={index} className="bg-white/95 backdrop-blur-sm text-gray-800 px-5 py-2 rounded-full text-sm font-medium border border-gray-200/50 shadow-lg">
                {badge}
              </div>
            ))}
          </div>
          
          {/* Content with strong background for readability */}
          <div className="bg-gray-900/70 backdrop-blur-md p-10 rounded-lg border border-white/10">
            <div className="space-y-8">
              <h1 className="text-4xl lg:text-6xl font-bold leading-[1.2] tracking-tight">
                <span className="block text-blue-300 text-2xl lg:text-3xl font-light mb-3">
                  Mentoria Profissional
                </span>
                <span className="block bg-gradient-to-r from-blue-400 via-blue-300 to-slate-300 bg-clip-text text-transparent drop-shadow-lg mb-1">
                  Terapia
                </span>
                <span className="block bg-gradient-to-r from-slate-300 via-blue-300 to-blue-400 bg-clip-text text-transparent drop-shadow-lg mb-1">
                  Psicossomática
                </span>
                <span className="block bg-gradient-to-r from-blue-400 to-slate-400 bg-clip-text text-transparent drop-shadow-lg">
                  Direta®
                </span>
              </h1>
              
              <p className="text-lg lg:text-xl text-gray-100 leading-relaxed font-light max-w-2xl mb-4">
                <strong className="font-semibold text-blue-300">A Ciência por trás do Milagre</strong>
              </p>
              <p className="text-lg lg:text-xl text-gray-100 leading-relaxed font-light max-w-2xl">
                A única formação no Brasil que integra <strong className="font-semibold">Medicina Germânica, Teoria Polivagal e Hipnose Psicossomática</strong> para identificar e tratar <strong className="font-semibold">a verdadeira origem emocional</strong> dos sintomas e <strong className="font-semibold">transformar vidas em tempo recorde</strong>.
              </p>
            </div>
          </div>
          
          <div className="pt-6 space-y-6">
            <div className="relative inline-block">
              <a 
                href="https://chk.eduzz.com/39VE7ZGDWR"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-12 py-5 rounded-sm font-semibold text-xl transition-all duration-300 shadow-2xl hover:shadow-blue-500/25 border-0 hover:scale-105"
              >
                Quero garantir minha vaga
              </a>
              {/* Black Friday Sticker */}
              <img 
                src="https://customer-assets.emergentagent.com/job_therapia-web/artifacts/4wyw5dx2_Untitled%20design%20%2851%29.png"
                alt="Black Friday"
                className="absolute -top-3 -right-3 w-16 h-16 object-contain drop-shadow-2xl transform rotate-12"
                style={{
                  filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.4))'
                }}
              />
            </div>
            
            <div className="flex items-center gap-8 text-sm text-gray-200 pt-2">
              <div className="flex items-center gap-3 bg-white/15 backdrop-blur-sm px-4 py-2 rounded-full border border-white/10">
                <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                <span className="text-white"><strong className="font-semibold">Próximo Módulo I:</strong> 07/02/26</span>
              </div>
              <div className="flex items-center gap-3 bg-white/15 backdrop-blur-sm px-4 py-2 rounded-full border border-white/10">
                <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                <span className="text-white">Formação 100% ao vivo</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Right - Professional Photo */}
        <div className="flex justify-center lg:justify-end">
          <div className="relative">
            {/* Main professional photo */}
            <div className="w-96 h-[500px] rounded-lg overflow-hidden shadow-2xl border-2 border-white/30 backdrop-blur-sm">
              <img 
                src={mockData.hero.profileImage}
                alt={mockData.mentor.name}
                className="w-full h-full object-cover object-center"
              />
            </div>
            
            {/* Subtle floating accent */}
            <div className="absolute -top-4 -left-4 w-96 h-[500px] border-2 border-blue-400/40 rounded-lg -z-10"></div>
            
            {/* AEMP Certification seal */}
            <div className="absolute -bottom-4 -right-4 bg-white/95 backdrop-blur-sm rounded-full p-3 shadow-xl border border-gray-200">
              <img 
                src={mockData.hero.aempLogo}
                alt="AEMP Certification"
                className="w-16 h-16 object-contain"
              />
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </section>
);

// Clean About Section
export const CleanAboutSection = () => (
  <section className="py-24 bg-white">
    <div className="container mx-auto px-8">
      <div className="max-w-4xl mx-auto text-center">
        
        <div className="space-y-6">
          
          {/* Compact Stylized Title Image */}
          <div className="flex justify-center">
            <img 
              src={mockData.mentor.titleImage}
              alt={mockData.mentor.name}
              className="max-w-xs h-auto object-contain"
            />
          </div>
          
          <div className="space-y-6 max-w-3xl mx-auto">
            <p className="text-lg text-gray-600 leading-relaxed font-light italic">
              "{mockData.mentor.bio}"
            </p>
            
            <p className="text-base text-gray-700 leading-relaxed">
              {mockData.mentor.quote}
            </p>
          </div>
          
          {/* Academic Credentials - Elegant Text Format */}
          <div className="pt-8 space-y-6 max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-50 via-gray-50 to-blue-50 p-8 rounded-sm border border-blue-200/50">
              {mockData.mentor.credentialsText.split('\n\n').map((paragraph, index) => (
                <p key={index} className="text-gray-700 leading-relaxed font-light text-justify mb-4 last:mb-0">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </section>
);

// Clean Skills Section with Scientific Dark Background
export const CleanSkillsSection = () => (
  <section 
    className="py-24 relative"
    style={{
      backgroundImage: `url('${mockData.scientificImages.neuralNetwork}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }}
  >
    {/* Dark blue overlay with gradient */}
    <div className="absolute inset-0 bg-gradient-to-b from-blue-900/60 via-blue-800/50 to-blue-900/80"></div>
    
    <div className="relative z-10 container mx-auto px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-medium text-white mb-6">
            Habilidades que você vai desenvolver
          </h2>
          <p className="text-lg text-gray-200 font-light max-w-3xl mx-auto">
            <strong className="font-semibold">Competências científicas</strong> aplicáveis para transformar sua prática profissional
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {mockData.skills.map((skill, index) => (
            <div key={index} className="flex items-start gap-4 p-8 bg-white/10 backdrop-blur-sm rounded-sm border border-white/20 hover:bg-white/15 transition-all duration-300">
              <div className="w-1.5 h-1.5 bg-blue-300 rounded-full mt-3 flex-shrink-0"></div>
              <p className="text-gray-100 leading-relaxed font-light">{skill}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

// Clean Benefits Section with Blue and Silver Gradient Cards
export const CleanBenefitsSection = () => (
  <section className="py-24 bg-white">
    <div className="container mx-auto px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-medium text-gray-800 mb-6">
            Benefícios da formação
          </h2>
          <p className="text-lg text-gray-600 font-light max-w-3xl mx-auto">
            Uma experiência de formação desenhada para <strong className="font-semibold">excelência profissional</strong>. Adquirirá uma <strong className="font-semibold">visão clínica tão precisa que parecerá mágica</strong>, mas é pura neurobiologia aplicada.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockData.benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="p-8 rounded-sm border border-blue-300/60 hover:shadow-xl hover:shadow-blue-500/20 transition-all duration-300 h-full hover:scale-105"
              style={{
                background: 'linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 15%, #bfdbfe 30%, #dbeafe 45%, #e0e7ff 60%, #e2e8f0 75%, #f1f5f9 90%, #e2e8f0 100%)'
              }}
            >
              <div className="flex flex-col h-full">
                {/* Small accent line */}
                <div className="w-12 h-1 bg-gradient-to-r from-blue-600 to-slate-500 rounded-full mb-4"></div>
                
                {/* Title with AEMP logo for certification benefit */}
                <div className="flex items-center gap-3 mb-4">
                  <h3 className="text-lg font-medium text-gray-800 leading-tight">
                    {benefit.title}
                  </h3>
                  {benefit.title.includes("AEMP") && (
                    <img 
                      src={mockData.hero.aempLogo}
                      alt="AEMP Logo"
                      className="w-8 h-8 object-contain"
                    />
                  )}
                </div>
                
                <p className="text-gray-700 leading-relaxed font-light flex-1">
                  {benefit.description}
                </p>
                
                {/* Small decorative element */}
                <div className="mt-4 pt-4 border-t border-blue-300/40">
                  <div className="w-2 h-2 bg-gradient-to-r from-blue-500 to-slate-500 rounded-full"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Disclaimer */}
        <div className="mt-12 max-w-4xl mx-auto">
          <p className="text-sm text-gray-500 font-light leading-relaxed text-center italic">
            *A formação não habilita o profissional a atuar de modo diferente de sua regulação profissional ou conselho de classe. O método é apresentado como ferramenta de intervenção, formação e atualização profissional, e não como substituto de psicoterapia regulamentada ou supervisão clínica.
          </p>
        </div>
      </div>
    </div>
  </section>
);

// Clean Video Section
export const CleanVideoSection = () => {
  const videoId = mockData.video.youtubeId;

  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-medium text-gray-800 mb-6">
            {mockData.video.title}
          </h2>
          <p className="text-lg text-gray-600 font-light mb-12">
            <strong className="font-semibold">Acesse o núcleo real da doença</strong> tratando a raiz, e não o sintoma.
          </p>
          
          <div className="relative aspect-video bg-white rounded-sm overflow-hidden shadow-xl border border-gray-200">
            <iframe
              src={`https://www.youtube.com/embed/${videoId}`}
              title={mockData.video.title}
              className="w-full h-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};

// Clean Scientific Bases Section with Molecular Background
export const CleanScientificBasesSection = () => (
  <section 
    className="py-24 relative"
    style={{
      backgroundImage: `url('${mockData.scientificImages.molecules}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }}
  >
    {/* Dark blue overlay with gradient */}
    <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-blue-900/60 to-slate-900/80"></div>
    
    <div className="relative z-10 container mx-auto px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-medium text-white mb-6">
            As 3 Bases Científicas da Formação
          </h2>
          <p className="text-lg text-gray-200 font-light max-w-3xl mx-auto">
            Fundamentos científicos que sustentam a <strong className="font-semibold">Terapia Psicossomática Direta®</strong>
          </p>
        </div>

        <div className="space-y-20">
          {mockData.scientificBases.map((base, index) => (
            <div key={index} className={`grid lg:grid-cols-2 gap-16 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
              <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <div className="aspect-video rounded-sm overflow-hidden shadow-2xl border border-white/20 bg-white/5 backdrop-blur-sm">
                  <img 
                    src={base.image}
                    alt={base.title}
                    className="w-full h-full object-cover"
                    style={{
                      imageRendering: 'auto',
                      imageRendering: '-webkit-optimize-contrast'
                    }}
                  />
                </div>
              </div>
              
              <div className={`space-y-6 ${index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}`}>
                <div className="bg-white/10 backdrop-blur-sm p-8 rounded-sm border border-white/20">
                  <h3 className="text-2xl lg:text-3xl font-medium text-white mb-4">
                    {base.title}
                  </h3>
                  <p className="text-lg text-gray-200 leading-relaxed font-light">
                    {index === 0 && (
                      <>Aprenda a aplicar as <strong className="font-semibold">5 Leis Biológicas</strong> do Dr. Hamer que revelam a lógica biológica por trás dos sintomas, proporcionando uma compreensão revolucionária do processo saúde-doença.</>
                    )}
                    {index === 1 && (
                      <>Compreenda como a <strong className="font-semibold">ciência do sistema nervoso autônomo</strong> explica a regulação emocional, a segurança interna e os mecanismos de cura psicossomática.</>
                    )}
                    {index === 2 && (
                      <>Acesse diretamente o <strong className="font-semibold">Inconsciente Biológico</strong> para transformar crenças limitantes, padrões, dissolver traumas e <strong className="font-semibold">restaurar a função orgânica</strong> natural do corpo.</>
                    )}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default { CleanHeroSection, CleanAboutSection, CleanSkillsSection, CleanBenefitsSection, CleanVideoSection, CleanScientificBasesSection };